import { ChevronRight, X } from 'lucide-react';

const ChatPanel = ({ chatMessages, newMessage, setNewMessage, onSend, onClose, onKeyPress }) => (
  <div className="w-80 bg-white border-l flex flex-col">
    <div className="p-3 border-b flex justify-between items-center">
      <h2 className="font-medium">Property Assistant</h2>
      <button className="text-gray-400 hover:text-gray-600" onClick={onClose}>
        <X size={18} />
      </button>
    </div>

    <div className="flex-1 overflow-y-auto p-3 space-y-4">
      <div className="bg-gray-100 p-3 rounded-lg text-sm">
        <b>Selected Parcels</b>
        <p className="text-gray-600">0 University Pkwy, Sarasota</p>
        <p className="text-gray-600">2250 Fruitville Rd, Sarasota</p>
      </div>
      {chatMessages.map((msg, i) => (
        <div
          key={i}
          className={`${msg.sender === 'user' ? 'bg-blue-100 ml-6' : 'bg-gray-100 mr-6'} p-2 rounded-lg text-sm`}
        >
          {msg.message}
        </div>
      ))}
    </div>

    <div className="p-3 border-t flex">
      <input
        type="text"
        placeholder="Ask a question..."
        className="flex-1 p-2 border rounded-l-md focus:outline-none focus:ring-1 focus:ring-blue-500"
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        onKeyPress={onKeyPress}
      />
      <button
        onClick={onSend}
        className="bg-blue-600 text-white p-2 rounded-r-md hover:bg-blue-700"
      >
        <ChevronRight size={18} />
      </button>
    </div>
  </div>
);

export default ChatPanel;
